module.exports = {
  REDIRECT_INIT: 'REDIRECT_INIT',
  REDIRECT_DONE: 'REDIRECT_DONE',
};
